import { render, staticRenderFns } from "./ComApilimit.vue?vue&type=template&id=7ec9c5ee&scoped=true&"
import script from "./ComApilimit.vue?vue&type=script&lang=js&"
export * from "./ComApilimit.vue?vue&type=script&lang=js&"
import style0 from "./ComApilimit.vue?vue&type=style&index=0&id=7ec9c5ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9c5ee",
  null
  
)

export default component.exports